<template>
  <div class="p-pickup__item" :class="{
    'has-link': item.pickup_link ? true : false
  }">
    <a :href="item.pickup_link" class="p-pickup__link" target="_blank">
      <div class="p-pickup__image">
        <img :src="item.pickup_image.url" :alt="item.pickup_image.title" class="u-cover">
        <span class="p-pickup__type" v-text="item.pickup_type"></span>
      </div>
      <dl class="p-pickup__description">
        <dt>
          <em v-if="item.pickup_link">{{ item.pickup_title }}<i class="icon-external"></i></em>
          <span v-else v-text="item.pickup_title"></span>
        </dt>
        <dd v-html="item.pickup_lead"></dd>
      </dl>
    </a>
    <div v-if="item.pickup_map_url" class="p-pickup__mapUrl">
      <a :href="item.pickup_map_url" target="_blank" class="c-externalLink" data-type="map"><i class="icon-access"></i>Open Google Map</a>
    </div>
  </div>
</template>

<script>
  /**
   * Share Partial
   */

  export default {
    name: 'pickup-item',
    props: {
      item: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        isHovered: false,
      }
    },
    methods: {
      onMouseenter(e) {
        this.isHovered = true
      },
      onMouseleave(e) {
        this.isHovered = false
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/partial/pickup-item.vue